import { colors } from "@mui/material";

const colorConfigs = {
  sidebar: {
    bg: "#223d57", // 45535c   // 223d57  f0f3f5   454b4f
    color: "#eeeeee",
    hoverBg: "#20384f",//"#1e293a",  13273a
    activeBg: "#2c4b68" //"#1e253a"  122f4b
  },
  topbar: {
    bg: "#fff",
    color: "#000"
  },
  mainBg: colors.grey["100"]
};

export default colorConfigs;